var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
__name(_typeof, "_typeof");
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
__name(_extends, "_extends");
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
__name(_classCallCheck, "_classCallCheck");
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
__name(_defineProperties, "_defineProperties");
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: false }), e;
}
__name(_createClass, "_createClass");
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
__name(_callSuper, "_callSuper");
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
__name(_possibleConstructorReturn, "_possibleConstructorReturn");
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
__name(_assertThisInitialized, "_assertThisInitialized");
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t2) {
  }
  return (_isNativeReflectConstruct = /* @__PURE__ */ __name(function _isNativeReflectConstruct2() {
    return !!t;
  }, "_isNativeReflectConstruct"))();
}
__name(_isNativeReflectConstruct, "_isNativeReflectConstruct");
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t2) {
    return t2.__proto__ || Object.getPrototypeOf(t2);
  }, _getPrototypeOf(t);
}
__name(_getPrototypeOf, "_getPrototypeOf");
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf(t, e);
}
__name(_inherits, "_inherits");
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t2, e2) {
    return t2.__proto__ = e2, t2;
  }, _setPrototypeOf(t, e);
}
__name(_setPrototypeOf, "_setPrototypeOf");
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
__name(_defineProperty, "_defineProperty");
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
__name(_toPropertyKey, "_toPropertyKey");
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
__name(_toPrimitive, "_toPrimitive");
import React, { Component } from "react";
import { ArtFrameItem } from "./Item";
import { ArtOptionLabel } from "../label/Label";
import { artOptionFrameCls, artOptionFrameListCls, artOptionFrameListItemCls } from "./Frame.less";
var FRAMENAME_TO_CLASSNAME = {
  no_frame: "none",
  white_frame: "white",
  black_frame: "black",
  walnut_frame: "walnut"
};
var DEFAULT_FRAMENAME = Object.keys(FRAMENAME_TO_CLASSNAME)[0];
function getSelectedFrame(frameId) {
  var frames = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  return frames.filter(function(_ref) {
    var id = _ref.id;
    return id === frameId;
  })[0] || {};
}
__name(getSelectedFrame, "getSelectedFrame");
var ArtOptionFrame = /* @__PURE__ */ function(_Component) {
  function ArtOptionFrame2(props) {
    var _this;
    _classCallCheck(this, ArtOptionFrame2);
    _this = _callSuper(this, ArtOptionFrame2, [props]);
    _this.bindMethods();
    _this.state = {
      selectedFrame: getSelectedFrame(_this.props.selectedFrameId, _this.props.options && _this.props.options.frames) || {}
    };
    return _this;
  }
  __name(ArtOptionFrame2, "ArtOptionFrame");
  _inherits(ArtOptionFrame2, _Component);
  return _createClass(ArtOptionFrame2, [{
    key: "handleClick",
    value: /* @__PURE__ */ __name(function handleClick() {
      var _this2 = this;
      var frame = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      return function(e) {
        e.preventDefault();
        var _this2$props = _this2.props, onFrameChange = _this2$props.onFrameChange, controlled = _this2$props.controlled;
        var selectedFrame = _this2.state.selectedFrame;
        if (frame && frame.id === selectedFrame.id) {
          return;
        }
        var newFrame = frame && selectedFrame.id !== frame.id ? frame : {};
        if (controlled) {
          _this2.setState({
            selectedFrame: newFrame
          });
        }
        if (typeof onFrameChange === "function") {
          onFrameChange(newFrame);
        }
      };
    }, "handleClick")
    /**
     * bindMethods
     */
  }, {
    key: "bindMethods",
    value: /* @__PURE__ */ __name(function bindMethods() {
      this.handleClick = this.handleClick.bind(this);
    }, "bindMethods")
    /**
     * render
     *
     * @returns {Node}
     */
  }, {
    key: "render",
    value: /* @__PURE__ */ __name(function render() {
      var _this3 = this;
      var _this$props = this.props, options = _this$props.options, _this$props$translati = _this$props.translations, translations = _this$props$translati === void 0 ? {} : _this$props$translati, Hint = _this$props.hint, hintOptions = _this$props.hintOptions, readOnly = _this$props.readOnly;
      var canBeFramed = options.canBeFramed, _options$frames = options.frames, frames = _options$frames === void 0 ? [] : _options$frames;
      var selectedFrame = this.state.selectedFrame;
      if (canBeFramed && frames.length) {
        return /* @__PURE__ */ React.createElement("div", {
          className: artOptionFrameCls
        }, /* @__PURE__ */ React.createElement(ArtOptionLabel, {
          uppercase: !readOnly
        }, !readOnly ? /* @__PURE__ */ React.createElement(React.Fragment, null, selectedFrame.title ? /* @__PURE__ */ React.createElement("span", null, translations.framed, ":") : /* @__PURE__ */ React.createElement("span", null, translations.addFrame), " ") : null, readOnly && !selectedFrame.id && translations.unframed, typeof translations.frameLabel === "function" && selectedFrame.title ? /* @__PURE__ */ React.createElement("span", null, translations.frameLabel(selectedFrame.title, readOnly)) : null), !readOnly ? /* @__PURE__ */ React.createElement("ul", {
          className: artOptionFrameListCls
        }, /* @__PURE__ */ React.createElement(Hint, _extends({
          wrapperTag: "li",
          text: translations.noFrame,
          wrapperClassName: artOptionFrameListItemCls,
          placement: "NW"
        }, hintOptions), /* @__PURE__ */ React.createElement(ArtFrameItem, {
          color: FRAMENAME_TO_CLASSNAME.no_frame,
          isActive: !selectedFrame.id,
          onClick: this.handleClick()
        })), frames.map(function(frame) {
          var id = frame.id, title = frame.title, _frame$colorKey = frame.colorKey, colorKey = _frame$colorKey === void 0 ? DEFAULT_FRAMENAME : _frame$colorKey, priceLabel = frame.priceLabel;
          var hintLabel = title ? "".concat(title, " (+ ").concat(priceLabel, ")") : "";
          return /* @__PURE__ */ React.createElement(Hint, _extends({
            key: "frame-".concat(id),
            wrapperTag: "li",
            wrapperClassName: artOptionFrameListItemCls,
            placement: "NW",
            text: hintLabel
          }, hintOptions), /* @__PURE__ */ React.createElement(ArtFrameItem, {
            color: FRAMENAME_TO_CLASSNAME[colorKey],
            isActive: id === selectedFrame.id,
            onClick: _this3.handleClick(frame)
          }, title ? title.charAt(0) : null));
        })) : null);
      }
      return null;
    }, "render")
  }], [{
    key: "getDerivedStateFromProps",
    value: /* @__PURE__ */ __name(function getDerivedStateFromProps(props, state) {
      if (props.controlled) {
        return null;
      }
      if (props.selectedFrameId !== state.selectedFrame.id) {
        return {
          selectedFrame: getSelectedFrame(props.selectedFrameId, props.options.frames)
        };
      }
      return null;
    }, "getDerivedStateFromProps")
    /**
     * handleFrameChange
     *
     * @param {?Object} frame
     * @returns {Function}
     */
  }]);
}(Component);
_defineProperty(ArtOptionFrame, "defaultProps", {
  controlled: false,
  readOnly: false,
  hintOptions: {}
});
export {
  ArtOptionFrame
};
